// src/pages/HomePage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Typography, CircularProgress } from '@mui/material';

// Danh sách này PHẢI khớp với thứ tự và permission trong Sidebar.js
const allMenuItems = [
    { path: '/dashboard', permission: 'viewDashboard' },
    { path: '/hang-nhap', permission: 'viewImports' },
    { path: '/hang-xuat', permission: 'viewExports' },
    { path: '/ton-kho', permission: 'viewInventory' },
    { path: '/bao-cao', permission: 'viewReports' },
    { path: '/cong-no-nhap', permission: 'viewPayable' },
    { path: '/cong-no-xuat', permission: 'viewReceivable' },
    { path: '/theo-doi-vo-can', permission: 'viewCanTracking' },
    { path: '/nhan-vien', permission: 'viewPersonnel' },
    { path: '/theo-doi-don-hang', permission: 'viewOrderTracking' },
];

function HomePage() {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !currentUser) {
      return; // Chờ cho đến khi thông tin người dùng được tải xong
    }

    const isSuperUser = currentUser.roleNames?.some(name => name.toLowerCase() === 'admin') || currentUser.permissions?.full_access;

    if (isSuperUser) {
      navigate('/dashboard', { replace: true }); // Admin/SuperUser luôn được chuyển đến Dashboard
      return;
    }

    // Tìm trang đầu tiên người dùng được phép truy cập trong danh sách
    const firstAllowedPage = allMenuItems.find(item => 
      currentUser.permissions?.[item.permission]
    );

    if (firstAllowedPage) {
      // Nếu tìm thấy, chuyển hướng đến trang đó
      navigate(firstAllowedPage.path, { replace: true });
    }
    // Nếu không tìm thấy trang nào, component sẽ hiển thị thông báo "Không có quyền" bên dưới

  }, [currentUser, loading, navigate]);

  // Hiển thị vòng xoay trong khi chờ tải dữ liệu người dùng
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Hiển thị nếu người dùng không có quyền truy cập bất kỳ trang nào
  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography variant="h5">Không có quyền truy cập</Typography>
      <Typography>Bạn không có quyền để xem bất kỳ trang nào trong hệ thống. Vui lòng liên hệ quản trị viên để được cấp quyền.</Typography>
    </Box>
  );
}

export default HomePage;
